<template>
  <app-layout style="padding-top: 0px">
    <div slot="conteudo">
      <v-alert color="blue-grey" style="margin: 0 5px 5px 5px">
        <h4 style="color: white">Convênio TCE/MA</h4>
      </v-alert>
      <v-form
        :disabled="!userHasPermission()"
        v-model="valid"
        lazy-validation
        ref="form"
      >
        <v-container>
          <v-row>
            <v-col cols="12" md="4" style="margin-top: 1.1%">
              <v-select
                  solo
                  dense
                  v-model="convenio.tipoConvenio"
                  :items="tiposCon"
                  item-text="descricao"
                  item-value="tipoConvenioId"
                  label="Tipo de Convênio"
                  :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                  return-object
              ></v-select>
            </v-col>

            <v-col cols="12" md="2">
              <v-text-field
                  type="text"
                  label="Número da Parceria"
                  required
                  :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                  v-model="convenio.numeroParceria"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2">
              <v-text-field
                  type="number"
                  label="Ano da Parceria"
                  required
                  :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                  v-model="convenio.anoParceria"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2">
              <v-text-field
                  type="text"
                  label="Vigência da Parceria"
                  required
                  :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                  v-model="convenio.vigenciaParceria"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="3">
              <v-text-field
                  type="text"
                  label="Nº Processo"
                  required
                  :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                  v-model="convenio.numeroProcesso"
                  @input="validateNumber"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                label="Ano do Processo"
                type="number"
                required
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                v-model="convenio.anoProcesso"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                label="Data de Assinatura"
                type="date"
                required
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
                v-model="convenio.dataAssinatura"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col md="5">
              <v-text-field
                outlined
                label="Parceiro"
                v-model="convenio.convenente"
              ></v-text-field>
            </v-col>
            <v-col md="5">
              <v-text-field
                outlined
                label="Responsável"
                v-model="convenio.responsavel"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="10">
              <v-textarea
                rows="2"
                outlined
                auto-grow
                counter
                name="textArea"
                label="Objeto"
                v-model="convenio.objeto"
                :rules="[(v) => !!v || 'Este campo é obrigatório!']"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="5">
              <v-file-input
                outlined
                required
                v-model="arquivo"
                label="UPLOAD"
                accept=".pdf"
                :placeholder="convenio.arquivo
                  ? convenio.arquivo.substring(0, 25) + '...'
                  : 'Selecione o arquivo'"
                show-size
                truncate-length="50"
              ></v-file-input>
            </v-col>
            <v-col>
              <v-tooltip bottom v-if="convenio.arquivo">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="download()"
                    dark
                    color="#606060"
                    depressed
                    class="rounded-pill mt-2 mr-2"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon class="">fas fa-file-download</v-icon>
                  </v-btn>
                </template>
                <span>Download do arquivo</span></v-tooltip
              >
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-btn
                color="primary"
                small
                depressed
                @click="salvar()"
                :disabled="!userHasPermission()"
              >
                Salvar
              </v-btn>
              <span></span>
              <v-btn
                style="margin-left: 2%"
                color="primary"
                small
                depressed
                to="/convenios"
                >Cancelar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </app-layout>
</template>

<script>
import convenioService from "@/service/ConvenioService";
import Convenio from "@/model/convenio";
export default {
  data() {
    return {
      valid: false,
      convenio: Convenio(),
      arquivo: null,
      tiposCon: [],
    };
  },
  methods: {
    validateNumber() {
      // Remove qualquer caracter que não seja número
      this.convenio.numeroProcesso = this.convenio.numeroProcesso.replace(
        /[^0-9]/g,
        ""
      );
    },

    download(){
      convenioService.downloadArquivo(this.$route.params.id)
    },
    salvar() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        convenioService
          .salvar(this.convenio, this.arquivo)
          .then((result) => {
            (this.convenio = result), alert("Documento Salvo!"), this.sair();
          })
          .catch((err) => console.error(err.message));
      } else {
        alert("Informe os campos Obrigatórios!");
      }
    },
    sair() {
      this.$router.push("/convenios");
    },
  },
  mounted() {
    if (this.$route.params.id != 0) {
      convenioService
        .buscarConvenio(this.$route.params.id)
        .then((res) => (this.convenio = res));
    }
  },
  created() {
    convenioService.findTiposConvenio().then((res) => (this.tiposCon = res));
  },
};
</script>

<style>
</style>